<template>

    <!-- Page Sidebar Ends-->
    <div class="page-body">
        <PageTitle title="Work Permit" />
        <div class="container-fluid">
            <div class="col-xxl-12">
                <div class="card">
                    <div class="card-header">
                       
                    </div>
                    <div class="card-body">
                        <ul class="nav nav-tabs border-tab border-0 mb-0 nav-danger" id="topline-tab" role="tablist">
                            <li class="nav-item"><a class="nav-link active nav-border pt-0 txt-danger nav-danger"
                                    id="all-gatepass-tab" data-bs-toggle="tab" href="#all-gatepass" role="tab"
                                    aria-controls="all-gatepass" aria-selected="true"><i
                                        class="icofont icofont-man-in-glasses"></i>All</a></li> 
                                        
                                        <li class="nav-item"><a class="nav-link nav-border txt-danger nav-danger" id="ongoing-tab"
                                            data-bs-toggle="tab" href="#ongoing" role="tab" aria-controls="ongoing"
                                            aria-selected="false"><i class="icofont icofont-listine-dots"></i>Active</a>
                                    </li>

                                    
                                    <li class="nav-item"><a class="nav-link nav-border txt-danger nav-danger" id="requested-tab"
                                            data-bs-toggle="tab" href="#requested" role="tab" aria-controls="requested"
                                            aria-selected="false"><i class="icofont icofont-listine-dots"></i>Expired</a>
                                    </li>

                                    <li>
                                        <button class="btn btn-primary" type="button" data-bs-toggle="modal"
                                        data-original-title="test" data-bs-target="#workpermitAdd"><i class="icofont icofont-plus"></i> Work Permit</button>
                                    </li>


                        </ul>
                        <div class="tab-content" id="topline-tabContent">
                            <div class="tab-pane fade show active" id="all-gatepass" role="tabpanel"
                                aria-labelledby="all-gatepass-tab">
                                <div class="card-body px-0 pb-0">
                                    <div class="user-header pb-2">
                                        <h6 class="fw-bold">All Work Permit:</h6>
                                        <button class="btn btn-primary text-white" v-if="reschedule.length > 0"
                                            data-bs-toggle="modal" data-original-title="test"
                                            data-bs-target="#rescheduleHere">Reschedule</button>
                                    </div>

                                    <div class="col-12 row mb-3">
                                        <div class="col-4">
                                          <label for="fromdate" class="form-label">From Date</label>
                                          <input class="form-control" type="date" id="fromdate" v-model="date.fromdate">
                                        </div>
                                        <div class="col-4">
                                          <label for="todate" class="form-label">To Date</label>
                                          <input class="form-control" type="date" id="todate" v-model="date.todate">
                                        </div>
                                        <div class="col-2 mt-4">
                                          <button class="btn btn-outline-warning" @click="filter" type="button">Filter</button>
                                        </div>
                                      </div>
                                      



                                    <div class="user-content">
                                        <div class="table-responsive custom-scrollbar">
                                            <table class="table display datatable" id="All">
                                                <thead>
                                                    <tr>
                                                        <!-- <th></th> -->
                                                        <th>SR</th>
                                                        <th>Register Date</th>
                                                        <th>Name</th>
                                                        <th>Company Name</th>
                                                        <th>Address</th>
                                                        <th>Contact</th>
                                                        <th>designation</th>
                                                        <th>Fromdate</th>
                                                        <th>Todate</th>
                                                        <th>Check In</th>
                                                        <th>Check Out</th>
                                                        <th>Action</th>
                                                        <th>Delete</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index)  in  workpermit">
                                                        <!-- <td><input type="checkbox" @click="() => { selectUsers(item.id) }"
                                                                :value="item.id" /></td> -->
                                                        <td>{{ index+1 }}</td>
                                                        <td>{{ item.iddate }}</td>
                                                    
                                                        <td>{{ item.name }} </td>
                                                        <td>{{ item.companyname }} </td>
                                                        <td>{{ item.address }}</td>
                                                        <td>{{ item.contact }}</td>
                                                        <td>{{ item.designation }} </td>

                                                        <td>{{ item.fromdate }}</td>
                                                        <td>{{ item.todate }}</td>

                                                        
                                                        <td>

                                                            <div v-if="!item.max_check_in && !item.max_check_out">
                                                            <button @click="checkinitem(item.id,status=1)" class="btn-primary">Check In</button>
                                                        </div>

                                                        <!-- <div v-else-if="item.max_check_in && item.max_check_out">
                                                            <button @click="checkinitem(item.id,status=1)" class="btn-primary">Check In</button>
                                                        </div> -->

                                                        <div v-else>
                                                            {{ item.max_check_in }}
                                                        </div>


                                                        </td>
                                                

                                                        <td>
                                                            <div v-if="item.max_check_in">
                                                                <button @click="checkinitem(item.id,status=2)" class="btn-primary">Check Out</button>
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <ul class="action">
                                                                <li class="link" 
                                                                    @click="getQrCode(item.token)"><i
                                                                        class="icofont icofont-qr-code"></i></li>

                                                                        
                                                            <router-link :to="`/workpermitdetails?id=${item.id}`">View</router-link>
                                                            </ul>
                                                          </td>                                                          
                                                          <td>
                                                            <button @click="deleteitem(item.id)" class="btn-primary">Delete</button>
                                                          </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          
                        </div>

             <!-- start Active Workpermit------------------------------------------------------------------------------------------------>

             <div class="tab-pane fade" id="ongoing" role="tabpanel" aria-labelledby="ongoing-tab">
                <div class="card-body px-0 pb-0">
                    <div class="user-header pb-2">
                        <h6 class="fw-bold">ACTIVE</h6>
                    </div>
                    <div class="col-12 row mb-3">
                        <div class="col-4">
                          <label for="fromdate" class="form-label">From Date</label>
                          <input class="form-control" type="date" id="fromdate" v-model="date.fromdate">
                        </div>
                        <div class="col-4">
                          <label for="todate" class="form-label">To Date</label>
                          <input class="form-control" type="date" id="todate" v-model="date.todate">
                        </div>
                        <div class="col-2 mt-4">
                          <button class="btn btn-outline-warning" @click="filter" type="button">Filter</button>
                        </div>
                      </div>
                    <div class="user-content">
                        <div class="table-responsive custom-scrollbar">
                            <table class="table display datatable" id="Active">
                                <thead>
                                    <tr>
                                        <!-- <th></th> -->
                                        <th>SR</th>
                                        <th>Register Date</th>
                                        <th>Name</th>
                                        <th>Company Name</th>
                                        <th>Address</th>
                                        <th>Contact</th>
                                        <th>designation</th>
                                        <th>Fromdate</th>
                                        <th>Todate</th>
                                        <th>Check In</th>
                                        <th>Check Out</th>
                                        <th>Action</th>
                                        <th>Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index)  in  workpermit" >
                                        <!-- <td><input type="checkbox" @click="() => { selectUsers(item.id) }"
                                                :value="item.id" /></td> -->
                                        <td>{{ index+1 }}</td>
                                        <td>{{ item.iddate }}</td>
                                    
                                        <td>{{ item.name }} </td>
                                        <td>{{ item.companyname }} </td>
                                        <td>{{ item.address }}</td>
                                        <td>{{ item.contact }}</td>
                                        <td>{{ item.designation }} </td>

                                        <td>{{ item.fromdate }}</td>
                                        <td>{{ item.todate }}</td>

                                        
                                        <td>

                                            <div v-if="compareDate(item.max_check_in,item.max_check_out)">
                                            <button @click="checkinitem(item.id,status=1)" class="btn-primary">Check In</button>
                                        </div>

                                        <div v-else>
                                            {{ item.max_check_in }}
                                        </div>


                                        </td>
                                

                                        <td>
                                            <div v-if="!compareDate(item.max_check_in,item.max_check_out)">
                                                <button @click="checkinitem(item.id,status=2)" class="btn-primary">Check Out</button>
                                            </div>
                                        </td>

                                        <td>
                                            <ul class="action">
                                                <li class="link" 
                                                    @click="getQrCode(item.token)"><i
                                                        class="icofont icofont-qr-code"></i></li>

                                                        
                                            <router-link :to="`/workpermitdetails?id=${item.id}`">View</router-link>
                                            </ul>
                                          </td>                                                          
                                          <td>
                                            <button @click="deleteitem(item.id)" class="btn-primary">Delete</button>
                                          </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
              <!-- end active workpermit------------------------------------------------------------------------------------------------->

           <!-- start expiry work-permit------------------------------------------------------------------------------------------------->

           <div class="tab-pane fade" id="requested" role="tabpanel" aria-labelledby="requested-tab">
            <div class="card-body px-0 pb-0">
                <div class="user-header pb-2">
                    <h6 class="fw-bold">Expired</h6>
                </div>
                <div class="user-content">
                    <div class="table-responsive custom-scrollbar">
                        <table class="table display datatable" id="Expired">
                            <thead>
                                <tr>
                                    <!-- <th></th> -->
                                    <th>SR</th>
                                    <th>Register Date</th>
                                    <th>Name</th>
                                    <th>Company Name</th>
                                    <th>Address</th>
                                    <th>Contact</th>
                                    <th>designation</th>
                                    <th>Fromdate</th>
                                    <th>Todate</th>
                                    <th>Check In</th>
                                    <th>Check Out</th>
                                    <th>Action</th>
                                    <th>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index)  in  workpermit" :key="item.workpermitid" if="!compareTodayDate(item.max_check_in,item.max_check_out)" >
                                    <!-- <td><input type="checkbox" @click="() => { selectUsers(item.id) }"
                                            :value="item.id" /></td> -->
                                    <td>{{ index+1 }}</td>
                                    <td>{{ item.iddate }}</td>
                                
                                    <td>{{ item.name }} </td>
                                    <td>{{ item.companyname }} </td>
                                    <td>{{ item.address }}</td>
                                    <td>{{ item.contact }}</td>
                                    <td>{{ item.designation }} </td>

                                    <td>{{ item.fromdate }}</td>
                                    <td>{{ item.todate }}</td>

                                    
                                    <td>

                                        <div v-if="compareDate(item.max_check_in,item.max_check_out)">
                                        <button @click="checkinitem(item.id,status=1)" class="btn-primary">Check In</button>
                                    </div>

                                    <div v-else>
                                        {{ item.max_check_in }}
                                    </div>


                                    </td>
                            

                                    <td>
                                        <div v-if="!compareDate(item.max_check_in,item.max_check_out)">
                                            <button @click="checkinitem(item.id,status=2)" class="btn-primary">Check Out</button>
                                        </div>
                                    </td>

                                    <td>
                                        <ul class="action">
                                            <li class="link" 
                                                @click="getQrCode(item.token)"><i
                                                    class="icofont icofont-qr-code"></i></li>

                                                    
                                        <router-link :to="`/workpermitdetails?id=${item.id}`">View</router-link>
                                        </ul>
                                      </td>                                                          
                                      <td>
                                        <button @click="deleteitem(item.id)" class="btn-primary">Delete</button>
                                      </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>












           <!--end expiry work-permit---------------------------------------------------------------------------------------------------->








                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="qrcodeView" tabindex="-1" role="dialog" aria-labelledby="qrcodeView" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">QR Code</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper ">
                        <div class="col-sm-12">
                            <canvas ref="qrcodeCanvas"></canvas>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12">

                    </div>
                </div>
            </div>
        </div>
    </div>
    <ModalsPart v-if="!['login'].includes($route.name)" @getworkpermitData="updateData" />
</template>
<style scoped>
.avatar {
    width: 50px;
    height: 50px;
    border-radius: 30px;
}

.badge_sm {
    padding: 2px 5px;
    border-radius: 10px;
    font-size: smaller;
    color: white;
}
</style>
<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue';
import ModalsPart from '@/components/Modals.vue';
import GatePass from '@/components/GatepassPrint.vue';
import Swal from 'sweetalert2';
import axios from 'axios';
import QRCode from 'qrcode';

export default {
    name: 'CreateGatepass',
    components: {
        PageTitle, ModalsPart, GatePass
    }, mounted() {
        this.getBasics();
        

    }, data() {
        const today = new Date().toISOString().split('T')[0]; // Formats to 'YYYY-MM-DD'
        return {
            reschedule: [],
            user: [],
            workpermit:[],
            active_workpermit:[],
            expired_workpermit:[],
            sd:0,
            date:{
                fromdate: today,
                todate: today
            },
            dataTable:null,
            today_data:today,

        }
    }, 
    methods: {

        updateData(value) {
            this.workpermit = value;
        },

        getBasics() {
            var self = this;
            axios.post('getworkpermit').then(function (response) {
                self.workpermit = response.data.workpermit;
                window.scrollTo(0, 0);
            }).then(() => {
               self.dataTable= $(".datatable").DataTable({
                    dom: 'Bfrtip',
                    buttons: ['excel', 'pdf'],
                    "paging": true,
                    "ordering": true,
                    "autoWidth": false
                });
            });


        },
        compareDate(checkInDate,checkOutDate) {
                return  new Date(checkOutDate) >  new Date(checkInDate);
                },
        compareTodayDate(checkInDate,checkOutDate) {
                if(new Date(today_data)>= new Date(checkInDate) && new Date(today_data)<= new Date(checkOutDate))
                    return true;
                else
                    return false;
                },


        deleteitem(id) {
        var self = this;
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you really want to delete this?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
        if (result.isConfirmed) {
            axios.post('deleteworkpermit', { id: id }).then(function (response) {
                self.workpermit = response.data.workpermit;
              
                window.scrollTo(0, 0);
                Swal.fire(
                    'Deleted!',
                    'The item has been deleted.',
                    'success'
                );
            });
        }
    });
},
async getQrCode(token) {
    alert(token);
            try {
                if (token.length > 0) {
                    const canvas = this.$refs.qrcodeCanvas;
                    //var url = this.$api_host + 'wp?q=' + token; 
                  this.$router.push(`/wp?q=${token}`);

                    alert(url);
                    //var url= 'http://192.168.1.8:8081/visitorgatepassview?q='+token;
                    await QRCode.toCanvas(canvas, url, { width: 200 });
                    $("#qrcodeView").modal("toggle");
                }

            } catch (error) {
                console.error(error);
            }
        },
    

        checkinitem(id,status) {
    var self = this;

    axios.post('checkinworkpermit', { id: id, status: status })
        .then(function (response) {
            self.workpermit = response.data.workpermit;
            self.status = response.data.status;
            self.message = response.data.message;
            if(self.status == 1){
                self.$swal(self.message);
            
            }else{
                self.$swal(self.message);
               
            }

            window.scrollTo(0, 0);

        })
   
},
 
destroyTable(){
    if ($.fn.dataTable.isDataTable('#All')) {
                                    $('#All').DataTable().destroy();
                                }
                if ($.fn.dataTable.isDataTable('#Active')) {
                                    $('#Active').DataTable().destroy();
                                }
                if ($.fn.dataTable.isDataTable('#Expired')) {
                                    $('#Expired').DataTable().destroy();
                }
},
refreshTable(){
    $("#All").DataTable({
                        dom: 'Bfrtip',
                        buttons: ['excel', 'pdf'],
                        "paging": true,
                        "ordering": true,
                        "autoWidth": false
                    });
                    
                    $("#Active").DataTable({
                        dom: 'Bfrtip',
                        buttons: ['excel', 'pdf'],
                        "paging": true,
                        "ordering": true,
                        "autoWidth": false
                    });
                    $("#Expired").DataTable({
                        dom: 'Bfrtip',
                        buttons: ['excel', 'pdf'],
                        "paging": true,
                        "ordering": true,
                        "autoWidth": false
                    });
}
,
filter() {
            var self = this;
            axios.post('filtergetworkpermit',self.date).then(function (response) {
               
                self.destroyTable();
                self.workpermit = response.data.workpermit;
                window.scrollTo(0, 0);
            }).then(() => {
                 self.refreshTable();
            });


        },



     
          
    }
}
</script>
